import $ from 'jquery'

export default function addSmoothScroll() {
  $(document).on('click', '.js-smooth-scroll[href^="#"]', function scroll(e) {
    e.preventDefault()

    $('html, body').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top - 210,
      },
      500,
    )
  })
}
